<template>
  <view class="search-nav-bar">
    <view
      class="left"
      @click="$router.push('/')"
    >
      <img
        :src="site?.site_logo"
        class="love"
      >
      <text>{{site?.site_name}}</text>
    </view>
    <view class="right">
      <input
        type="text"
        @input="onInput"
        @keyup.enter="onSearch"
        enterkeyhint="search"
        v-model="value"
        placeholder="请输入关键词"
      >
      <div
        @click="onSearch"
        class="search"
      >
        <img :src="search">
      </div>
    </view>
  </view>
</template>

<script>
import search from "@/assets/images/search.png";
import { computed } from "vue";
import { useStore } from "@/store";
export default {
  name: "SearchNavBar",

  props: {
    value: {
      type: [String, Number],
      default: "",
    },
  },
  setup(props, ctx) {
    const store = useStore();
    function onSearch() {
      ctx.emit("onSearch");
    }
    function onInput(e) {
      ctx.emit("update:value", e.target.value);
    }
    const site = computed(() => store.getters.wechatInfo?.site);
    return {
      onSearch,
      onInput,
      search,
      site,
    };
  },
};
</script>

<style lang="less" scoped>
.van-icon {
  display: flex;
  align-items: center;
}
.search-nav-bar {
  height: 50px;
  background: #ededed;
  padding: 0 @padding-base;
  .align-center();
  .space-between();
  .left {
    height: 100%;
    .align-center();
    .pointer();
    font-size: @font-size-lg;
    font-weight: bold;
    text {
      padding-left: @padding-sm;
    }
    .love {
      width: 25px;
    }
  }
  .right {
    width: 175px;
    border-radius: 30px;
    background-color: #e4e4e4;
    height: 30px;
    .align-center();
    .space-between();
    padding: 0 @padding-sm;
    .search {
      width: 20px;
      height: 100%;
      .align-center();
      img {
        width: 100%;
      }
    }
    input {
      width: 130px;
      background: transparent;
      padding: 0;
      border: none;
      font-size: @font-size-base;
    }
  }
}
</style>